var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redeem-action",on:{"click":_vm.openDetailPage}},[_c('img',{staticClass:"redeem-icon",attrs:{"src":require('@/assets/icons/coupon.svg'),"alt":"Redeem"}}),_c('div',{staticClass:"redeem-text"},[_vm._v("Redeem Code")])])}
var staticRenderFns = []

export { render, staticRenderFns }